import { getStore } from '../store/store';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';

export function getAttachmentTypeOnValidationFailed(composeId: string): ValidatedAttachmentType[] {
    const allTelemetryData = getStore().telemetryDataForFailedValidation.get(composeId);
    if (allTelemetryData) {
        return Object.keys(allTelemetryData).map(key => {
            return parseInt(key);
        });
    }
    return null;
}

export function didUserForceSendMessage(
    composeId: string,
    validatedAttachmentType: ValidatedAttachmentType
) {
    const store = getStore();
    const telemetryData = store.telemetryDataForFailedValidation.get(composeId);

    return telemetryData[validatedAttachmentType]?.forceSend;
}
